var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "thumbs-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.83325 8.33398V18.334",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5001 4.89935L11.6667 8.33268H16.5251C16.7838 8.33268 17.039 8.39292 17.2704 8.50864C17.5019 8.62435 17.7032 8.79236 17.8584 8.99935C18.0137 9.20634 18.1186 9.44664 18.1649 9.70121C18.2111 9.95578 18.1975 10.2176 18.1251 10.466L16.1834 17.1327C16.0824 17.4789 15.8719 17.783 15.5834 17.9994C15.2949 18.2157 14.944 18.3327 14.5834 18.3327H3.33341C2.89139 18.3327 2.46746 18.1571 2.1549 17.8445C1.84234 17.532 1.66675 17.108 1.66675 16.666V9.99935C1.66675 9.55732 1.84234 9.1334 2.1549 8.82084C2.46746 8.50828 2.89139 8.33268 3.33341 8.33268H5.63341C5.94348 8.33252 6.24736 8.24586 6.51088 8.08245C6.77439 7.91904 6.9871 7.68536 7.12508 7.40768L10.0001 1.66602C10.3931 1.67088 10.7799 1.76449 11.1316 1.93985C11.4833 2.1152 11.7909 2.36777 12.0313 2.67868C12.2716 2.9896 12.4387 3.35082 12.5199 3.73535C12.601 4.11989 12.5943 4.51779 12.5001 4.89935Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.56d458ae676b5f944d36fb488dee234e.svg";
export { ForwardRef as ReactComponent };